export const REQUEST_KEY = {
    CONNECTION_REQUEST: 1,
    GROUP_JOIN_REQUEST: 2,
    GROUP_INVITE: 3,
    ADHOC_INVITE: 4,
    KIDADHOC_INVITE: 5,
    KIDTEAM_INVITE: 6,
    DEVICE_INVITE: 7
};

const reqKeys = [
    REQUEST_KEY.CONNECTION_REQUEST,
    REQUEST_KEY.GROUP_JOIN_REQUEST,
    REQUEST_KEY.GROUP_INVITE,
    REQUEST_KEY.ADHOC_INVITE,
    REQUEST_KEY.KIDADHOC_INVITE,
    REQUEST_KEY.KIDTEAM_INVITE,
    REQUEST_KEY.DEVICE_INVITE
];

/**
 * notification id enum
 * https://confluence.garmin.com/display/DI/Request+and+Notification+Enum+List
 * */
const notifyIds = [];

for (let i = 1; i <= 124; i += 1) {
    if (i >= 110 && i <= 115) {
        continue;
    }
    notifyIds.push(i);
}

export const reqQueryString = reqKeys.map((reqKey) => `req=${reqKey}`).join('&');
export const idQueryString = notifyIds.map((notifyId) => `id=${notifyId}`).join('&');
